module.exports = __webpack_public_path__ + "img/avatar.8ade0ace.png";